import { RouteProps, RouteComponentProps, useRouteMatch } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { User } from 'oidc-client';
import { AppDispatch, ApplicationState } from '../store';
import Layout from './Layout';
import Loading from './Loading';
import AsyncStatus, { AsyncStatusEnum } from '../model/common/AsyncStatus';
import { loadUser, signinRedirect } from '../store/User';

type AuthRouteProps =
  RouteProps & {
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  };

const AuthRoute = function (props: AuthRouteProps) {
  const dispatch : AppDispatch = useDispatch();
  const match = useRouteMatch(props);
  const loadStatus = useSelector<ApplicationState, AsyncStatus>(state => state.user.loadStatus);
  const signinRedirectStatus = useSelector<ApplicationState, AsyncStatus>(state => state.user.signinRedirectStatus);
  const user = useSelector<ApplicationState, User | null>(state => state.user.user);
  
  useEffect(() => {
    if (match && loadStatus === AsyncStatusEnum.IDLE && !user) {
      dispatch(loadUser());
    }
  }, [match, loadStatus, dispatch]);
  
  useEffect(() => {
    if (match && loadStatus !== AsyncStatusEnum.IDLE && loadStatus !== AsyncStatusEnum.LOADING && 
      signinRedirectStatus !== AsyncStatusEnum.LOADING && (!user || user.expired)) {
      dispatch(signinRedirect({ path: window.location.pathname }));
    }
  }, [match, loadStatus, signinRedirectStatus, user, dispatch]);

  if (match) {
    if (!user || user.expired) {
      return (<Loading isLoading={true} />);
    }
    var renderedComponent = React.createElement(props.component, { ...props });
    return (
      <Layout>
        {renderedComponent}
      </Layout>
    );
  } else return null;
}

export default AuthRoute;